const ENV = process.env;
const resourceGroupBackendUrl = ENV.REACT_APP_BACKEND_RESOURCEGROUP_API_URL;

export const apiConfig = {
  resourceGroupApiUrl: `${resourceGroupBackendUrl}/`,
  tenantAPiUrl: `${resourceGroupBackendUrl}/tenants`,
  userAPiUrl: `${ENV.REACT_APP_BACKEND_API_URL}/`,
  subscriptionApiUrl: `${resourceGroupBackendUrl}/`,
  baseApiUrl: ENV.REACT_APP_BACKEND_API_URL,
  isDevelopment: ENV.REACT_APP_DEVELOPMENT === "1",
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/", //Enter_the_Graph_Endpoint_Here/v1.0/me"
};
